// extracted by mini-css-extract-plugin
export default {"totalStatistic":"index_totalStatistic__oGly8","table-toolbar":"index_table-toolbar__OXVgG","left":"index_left__LUAyL","right":"index_right__KypDP"};